import { UIHeading2, UIHeading4, UIText1, UIText3 } from '@cian/ui-kit';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardMobileLayout = {
  companionName?: string | null;
  companionTypeName: string;
  isIframe: boolean;
  companionIdStr?: string;
  handleClickBack: () => void;
  avatar: React.ReactNode;
  actions: React.ReactNode | null;
  offer: React.ReactNode | null;
  images: React.ReactNode | null;
  updateChatFiles: (isFirstLoad?: boolean) => void;
};

export const UserCardMobileLayout: React.VFC<TUserCardMobileLayout> = ({
  companionName,
  companionTypeName,
  companionIdStr,
  handleClickBack,
  avatar,
  actions,
  offer,
  images,
  updateChatFiles,
  isIframe,
}) => {
  const scrollContainer = React.useRef<HTMLImageElement>(null);
  const [isVisibleFixedHeader, setVisibilityFixedHeader] = React.useState<boolean>(false);

  const handleScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

      setVisibilityFixedHeader(scrollTop > 160);

      if (scrollHeight === scrollTop + offsetHeight) {
        updateChatFiles();
      }
    },
    [updateChatFiles],
  );

  React.useEffect(() => {
    if (isIframe) {
      updateChatFiles(true);
    }
  }, []);

  return (
    <div className={styles['container']} data-testid="UserCardMobileLayout">
      <div className={styles['header']}>
        <button className={styles['back_button']} onClick={handleClickBack} data-testid="back_button">
          <IconActionChevronLeft16 color="icon-main-default" />
        </button>
        {isVisibleFixedHeader && (
          <div className={styles['title__fixed']}>
            <div data-testid={'UserCardMobileLayoutName'}>
              <UIHeading4 color="text-primary-default">{companionName || companionIdStr}</UIHeading4>
            </div>
            <div data-testid={'UserCardMobileLayoutTypeName'}>
              <UIText3 color="gray60_100">{companionTypeName}</UIText3>
            </div>
          </div>
        )}
      </div>
      <div className={styles['scroll']} onScroll={handleScroll} ref={scrollContainer}>
        {avatar}
        <div className={styles['title']}>
          <div data-testid={'UserCardMobileLayoutName'}>
            <UIHeading2 color="text-primary-default">{companionName || companionIdStr}</UIHeading2>
          </div>
          <div data-testid={'UserCardMobileLayoutTypeName'}>
            <UIText1 color="gray60_100">{companionTypeName}</UIText1>
          </div>
        </div>
        {actions}
        {offer}
        {images}
      </div>
    </div>
  );
};
